import { Grid, styled } from "@mui/material";
import { HiOutlinePlusCircle } from "react-icons/hi";

export const Wrapper = styled(Grid)(() => ({
  paddingTop: "16px !important",
  heigth: "100%",
}));

export const PlusIcon = styled(HiOutlinePlusCircle)(() => ({
  marginRight: "8px",
}));

export const Title = styled("span")(() => ({
  font: "500 24px/32px Manrope",
  color: "#475467",
  textAlign: "center",
}));

export const DescriptionContainer = styled(Grid)(() => ({
  display: "flex",
}));

export const Description = styled("span")(() => ({
  font: "400 14px/20px Manrope",
  color: "#475467",
  textAlign: "center",
}));
